import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import './i18n';
import createSagaMiddleware from "redux-saga";
import reducer from './store/reducer/rootReducer';
import thunk from 'redux-thunk';
import { watchAppUser } from './store/sagas'
const componseEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  reducer,
  componseEnhancers(applyMiddleware(thunk, sagaMiddleware))
);

sagaMiddleware.run(watchAppUser)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

if (!window.Promise) {
  window.Promise = Promise;
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('sw.js')
    .then(function () {
      console.log('Service worker registered!');
    })
    .catch(function(err) {
      console.log(err);
    });
}

function welcomeNotification() {
  if ('serviceWorker' in navigator) {
    var options = {
      body: 'Welcome to MyGame - your interactive poker coach!!!',
      icon: 'https://storage.googleapis.com/badbeat-assets-prod/images/appIcons/72x72.png',
      dir: 'ltr',
      lang: 'en-US', // BCP 47,
      vibrate: [100, 50, 200],
      badge: 'https://storage.googleapis.com/badbeat-assets-prod/images/appIcons/72x72.png',
      tag: 'welcome-notification',
      renotify: true
    };

    navigator.serviceWorker.ready
      .then(function(swreg) {
        swreg.showNotification('MyGame', options);
      });
  }
}
Notification.requestPermission(function(result) {
  console.log('User Choice', result);
  if (result !== 'granted') {
    console.log('No notification permission granted!');
  } else {
    // welcomeNotification()
  }
});


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/